import { render, staticRenderFns } from "./SectorComponent.vue?vue&type=template&id=2e75627c"
import script from "./SectorComponent.vue?vue&type=script&lang=js"
export * from "./SectorComponent.vue?vue&type=script&lang=js"
import style0 from "./SectorComponent.vue?vue&type=style&index=0&id=2e75627c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports